import { render, staticRenderFns } from "./GestaoConsumidor.vue?vue&type=template&id=9403bff2&scoped=true"
import script from "./GestaoConsumidor.vue?vue&type=script&lang=js"
export * from "./GestaoConsumidor.vue?vue&type=script&lang=js"
import style0 from "./GestaoConsumidor.vue?vue&type=style&index=0&id=9403bff2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9403bff2",
  null
  
)

export default component.exports